import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { CrudForm, useEntityManager } from 'elentari'
import gestoresCentroCustoRepository from './GestoresCentroCustoRepository'
import UsuarioAutocomplete from '../../Usuarios/UsuarioAutocomplete'

const validate = data => {
  return {
    gestorId: data.gestorId ? undefined : 'Obrigatório'
  }
}

const GestoresCentroCustoForm = props => {
  const entityManager = useEntityManager({
    repository: gestoresCentroCustoRepository
  })
  const handleSubmit = data => {
    const centroCustoId = parseInt(props.match.params.id)
    return entityManager.onSubmit({
      ...data,
      centroCustoId
    })
  }
  return (
    <CrudForm
      {...props}
      {...entityManager}
      onSubmit={handleSubmit}
      validate={validate}
      withPaper
    >
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Field
            fullWidth
            label="Gestor"
            name="gestorId"
            realm="gestor"
            component={UsuarioAutocomplete}
          />
        </Grid>
      </Grid>
    </CrudForm>
  )
}

export default GestoresCentroCustoForm
